import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import ar from "@/i18n/ar.json";
import en from "@/i18n/en.json";

const dictionaries = { ar, en };

const I18nContext = createContext({ lang: "ar", t: (k) => k });

function getByPath(obj, path) {
  return path.split(".").reduce(
    (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
    obj
  );
}

export function I18nProvider({ children }) {
  const location = useLocation();

  const lang = useMemo(() => {
    if (location.pathname.startsWith("/en")) return "en";
    return "ar";
  }, [location.pathname]);

  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.ar;
    const t = (key, fallback) => {
      const val = getByPath(dict, key);
      if (val === undefined || val === "")
        return fallback !== undefined ? fallback : "";
      return val;
    };
    return { lang, t };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
